module.exports = __webpack_public_path__ + "img/head3.1918a133.png";